import { Badge } from "../ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import type { Pedido } from "../../types/pedido";

interface PedidoCardProps {
  pedido: Pedido;
  onClick: (pedido: Pedido) => void;
}

export function PedidoCard({ pedido, onClick }: PedidoCardProps) {
  const isCerrado = pedido.CERRAR_PRUEBA === true;
  const hasBitacora = !!pedido.BITACORA_LINK;
  const hasCliente = !!pedido.CLIENTE_LINK;

  let status: 'abierto' | 'cerrado' | 'reportes' = 'abierto';
  if (isCerrado && hasBitacora && hasCliente) {
    status = 'reportes';
  } else if (isCerrado) {
    status = 'cerrado';
  }

  let badgeClass = '';
  if (status === 'abierto') badgeClass = 'bg-green-100 text-green-700 border-green-200';
  else if (status === 'cerrado') badgeClass = 'bg-yellow-100 text-yellow-700 border-yellow-200';
  else if (status === 'reportes') badgeClass = 'bg-blue-100 text-blue-700 border-blue-200';

  return (
    <Card
      className="cursor-pointer hover:shadow-lg transition-shadow"
      onClick={() => onClick(pedido)}
    >
      <CardHeader>
        <CardTitle className="flex justify-between items-center">
          {pedido.numeroPedido}
          <Badge className={`uppercase tracking-wide border ${badgeClass}`}>
            {status}
          </Badge>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <div>
            <label className="text-muted-foreground">Fecha de Emisión</label>
            <p>{pedido.fechaEntrega ? (() => { const [y,m,d] = pedido.fechaEntrega.split('T')[0].split('-').map(Number); return new Date(y, m-1, d).toLocaleDateString('es-MX'); })() : '—'}</p>
          </div>
          <div>
            <label className="text-muted-foreground">Pruebas</label>
            <p>{pedido.pruebasSolicitadas.length} prueba(s)</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
